<template>
  <m-card v-bind="$attrs" v-on="$listeners">
    <v-card height="300" text class="py-2">
      <v-chart auto-resize :options="options" theme="light" />
    </v-card>
    <template v-slot:footer v-slot="loading">
      <m-elapsed :loading="loading"></m-elapsed>
    </template>
  </m-card>
</template>

<style>
.echarts {
  width: 100%;
  height: 100%;
}
</style>

<script>
import ECharts from "vue-echarts/components/ECharts";
import "echarts/lib/chart/line";
// import "echarts/lib/component/title";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
// import echartsTheme from 'ant-design-vue-echart-theme'

// ECharts.registerTheme("light", echartsTheme);

export default {
  inheritAttrs: false,
  components: {
    "v-chart": ECharts,
  },
  props: {
    opLegend: {
      default: () => ["Terlambat", "Sakit", "Izin", "Mangkir", "Pulang Cepat"],
    },
    opSeries: {
      default: () => [
        {
          name: "Terlambat",
          type: "line",
          data: [15, 10, 17, 12, 2, 14, 25],
        },
        {
          name: "Sakit",
          type: "line",
          data: [0, 2, 5, 0, 0, 10, 0],
        },
        {
          name: "Izin",
          type: "line",
          data: [0, 3, 5, 12, 2, 8, 3],
        },
        {
          name: "Mangkir",
          type: "line",
          data: [0, 0, 1, 2, 0, 5, 3],
        },
        {
          name: "Pulang Cepat",
          type: "line",
          data: [5, 6, 7, 2, 14, 4, 5],
        },
      ],
    },
    opX: {
      default: () => [
        "01/01/2019",
        "02/01/2019",
        "03/01/2019",
        "03/01/2019",
        "04/01/2019",
        "05/01/2019",
        "06/01/2019",
      ],
    },
  },
  data() {
    return {
      options: {
        // title: {
        //   text: "Pendapatan Harian",
        //   textStyle: {
        //     fontSize: 16,
        //     fontFamily: "Roboto"
        //     // color: this.$vuetify.theme.primary,
        //   }
        // },
        tooltip: {
          trigger: "axis",
          textStyle: {
            fontSize: 12,
            // color: this.$vuetify.theme.primary,
          },
        },
        legend: {
          // data: ["Roda 2", "Roda 4", "Total"],
          data: this.opLegend,
          // orient: "vertical",
          right: 10,
          // top: 20,
          // bottom: 20
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.opX,
        },
        yAxis: {
          type: "value",
        },
        series: this.opSeries,
      },
    };
  },

  methods: {},
};
</script>
